export const normalizeCurrency = (currency) => (
    ["EUR", "PLN"].includes(currency) ? currency : "EUR"
);

export const formatCurrency = (value, currency = "EUR") => {
    const normalizedCurrency = normalizeCurrency(currency);
    const locale = normalizedCurrency === "PLN" ? "pl-PL" : "et-EE";

    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency: normalizedCurrency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(Number(value || 0));
};
